if (!customElements.get('hafko-product-info')) {
  customElements.define('hafko-product-info', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-open-guide]');
      if (dialog && trigger) {
        const animateGuide = (opening) => {
          const mobile = window.matchMedia('(max-width: 749px)').matches;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const resting = { transform: 'translateY(0) scale(1)', opacity: 1 };
          // Reduce spatial motion without making the sheet appear instantly.
          const offscreen = reducedMotion
            ? { transform: resting.transform, opacity: 0 }
            : { transform: mobile ? 'translateY(100%)' : 'translateY(32px) scale(.98)', opacity: mobile ? 1 : 0 };
          // Preserve the current position if the user closes during entry.
          const current = this.guideAnimation ? {
            transform: getComputedStyle(dialog).transform,
            opacity: getComputedStyle(dialog).opacity,
          } : (opening ? offscreen : resting);
          this.guideAnimation?.cancel();
          this.guideAnimation = null;
          const animation = dialog.animate([current, opening ? resting : offscreen], {
            duration: reducedMotion ? 180 : (opening ? 460 : 320),
            easing: opening ? 'cubic-bezier(.22, 1, .36, 1)' : 'cubic-bezier(.4, 0, 1, 1)',
            fill: 'both',
          });
          this.guideAnimation = animation;
          animation.finished.then(() => {
            if (this.guideAnimation !== animation) return;
            this.guideAnimation = null;
            if (!opening) dialog.close();
            animation.cancel();
          }).catch(() => {}); // An interrupted animation is expected on rapid clicks.
        };
        const closeGuide = () => {
          if (!dialog.open || !dialog.hasAttribute('data-visible')) return;
          dialog.removeAttribute('data-visible');
          dialog.setAttribute('data-closing', '');
          animateGuide(false);
        };
        trigger.addEventListener('click', () => {
          if (dialog.open && dialog.hasAttribute('data-visible')) return;
          dialog.removeAttribute('data-closing');
          if (!dialog.open) dialog.showModal();
          dialog.setAttribute('data-visible', '');
          trigger.setAttribute('aria-expanded', 'true');
          animateGuide(true);
        }, options);
        this.querySelector('[data-close-guide]').addEventListener('click', closeGuide, options);
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeGuide();
        }, options);
        dialog.addEventListener('click', (event) => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeGuide();
        }, options);
        dialog.addEventListener('close', () => {
          this.guideAnimation?.cancel();
          this.guideAnimation = null;
          dialog.removeAttribute('data-visible');
          dialog.removeAttribute('data-closing');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }, options);
        this.querySelectorAll('.pdp-info__size-chart tbody tr').forEach((row) => {
          const cell = row.cells[0];
          if (cell && /^(S|M|L|XL)$/.test(cell.textContent.trim()) && !cell.querySelector('.pdp-info__size-badge')) {
            const badge = document.createElement('span');
            badge.className = 'pdp-info__size-badge';
            badge.textContent = cell.textContent.trim();
            cell.replaceChildren(badge);
          }
        });
      }

      const prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
      const updatePrice = (id) => {
        const variant = prices[id];
        if (!variant) return;
        this.querySelector('[data-price]').innerHTML = variant.price;
        this.querySelector('[data-compare-value]').innerHTML = variant.compare;
        this.querySelector('[data-compare]').hidden = !variant.onSale;
        this.querySelector('[data-saving]').hidden = !variant.onSale;
        this.querySelector('[data-saving-value]').textContent = variant.saving;
      };
      document.addEventListener('variant:update', (event) => {
        if (event.detail?.data?.productId && String(event.detail.data.productId) !== this.dataset.productId) return;
        updatePrice(event.detail?.resource?.id);
      }, options);
      document.addEventListener('change', (event) => {
        if (event.target.matches('form[action*="/cart/add"] [name="id"]')) updatePrice(event.target.value);
      }, options);
      window.addEventListener('popstate', () => {
        updatePrice(new URL(window.location.href).searchParams.get('variant'));
      }, options);
    }

    disconnectedCallback() {
      this.guideAnimation?.cancel();
      this.guideAnimation = null;
      this.controller?.abort();
      const dialog = this.querySelector('dialog');
      dialog?.removeAttribute('data-visible');
      dialog?.removeAttribute('data-closing');
      dialog?.close();
    }
  });
}
